import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import http from '../http';
import store from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition);
        } else {
          resolve({ x: 0, y: 0 });
        }
      });
    });
  }
});

router.beforeEach((to, from, next) => {
  // const brandQuery = window.sessionStorage.getItem('BRAND_QUERY')
  // Checked: webChat Page and param
  if (to.path.includes('/webChat') && Object.keys(to.query).length === 0) {
    next();
    alert('잘못된 접근입니다.');
    window.close();
  } else {
    if (to.query.sid) {
      window.localStorage.setItem(process.env.VUE_APP_UUID_KEY, to.query.sid);
    }

    if (to.query.loginId && to.query.loginId.replace(/(\s*)/g, '').length > 0) {
      const loginId = to.query.loginId.replace(/(\s*)/g, '');
      window.localStorage.setItem(process.env.VUE_APP_LOGIN_ID, loginId);
    }

    // if (to.query.brandKey && brandQuery && JSON.parse(brandQuery).brandKey !== to.query.brandKey) {
    //     window.sessionStorage.removeItem('HEADER_STYLE')
    // }
    if (to.query && to.query.brandKey) {
      window.sessionStorage.setItem('BRAND_QUERY', JSON.stringify(to.query));
    }
    getAuthInfo(to, from, next).then((data) => {
      if (data) {
        // window.sessionStorage.setItem('HEADER_STYLE', JSON.stringify(data))
        store.commit('setHeaderStyle', data.styleData);
        store.commit('setCustomOptionInfos', data.customOptionInfos);

        // 헥토이노베이션 커스텀 start
        const hecto = data.customOptionInfos && data.customOptionInfos.find((option) => option.name === 'CHAT_BOT_AUTHENTICATION');
        if (to.name === 'webchatIndex' && hecto && hecto.use) {
          router.replace({ name: 'webchatIndexHecto', query: to.query });
        } else if (to.name === 'authNotice' && to.query && to.query.hecto === 'true') {
          router.replace({ name: 'authNoticeHecto' });
        }
        // 헥토이노베이션 커스텀 end
      }
      next();
    });
  }
});

const getAuthInfo = (to) => {
  return new Promise(function (resolve) {
    const brandQuery = window.sessionStorage.getItem('BRAND_QUERY') ? JSON.parse(window.sessionStorage.getItem('BRAND_QUERY')) : undefined;
    http({
      url: '/api/external/chatStyle/v2/fetchChatStyleData',
      method: 'get',
      params: {
        brandKeyEncrypt: brandQuery ? brandQuery.brandKey : to.query.brandKey,
        type: brandQuery ? brandQuery.channelType : to.query.channelType
      }
    })
      .then((res) => {
        const result = res.data.data;
        const styleData = {
          toolbarBackgroundColor: result.toolbarBackgroundColor || '#7f51ff',
          toolbarTitle: result.toolbarTitle || '실시간 채팅 문의',
          toolbarTitleColor: result.toolbarTitleColor || 'white',
          toolbarComment: result.toolbarComment || '보통 30분 내에 응답합니다',
          toolbarCommentColor: result.toolbarCommentColor || 'white',
          toolbarIconPath: result.toolbarIconPath || '',
          toolbarIconUrl: result.toolbarIconUrl || '',
          toolbarAgentName: result.toolbarAgentName || '상담사',
          toolbarAgentIconPath: result.toolbarAgentIconPath,
          toolbarAgentIconUrl: result.toolbarAgentIconUrl,
          isVersion2: true
        };

        resolve({ styleData: styleData, customOptionInfos: result.customOptionInfos });
      })
      .catch(() => {
        resolve({
          styleData: {
            toolbarBackgroundColor: '#7f51ff',
            toolbarTitle: '실시간 채팅 문의',
            toolbarTitleColor: 'white',
            toolbarComment: '보통 30분 내에 응답합니다',
            toolbarCommentColor: 'white',
            toolbarIconPath: '',
            toolbarIconUrl: '',
            toolbarAgentName: '상담사'
          },
          customOptionInfos: []
        });
      });
  });
};

export default router;
